import React, { useState, useEffect } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Tabs } from 'antd';
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons';
import { connect, useDispatch, useSelector } from "react-redux";
import { Details } from '@mui/icons-material';
import Spinner from '../../UIComponents/Spinner/Spinner';
import { doUpdateStorePic, StoreList, storeViewDetails } from './actions/storeService'
import Cookie from 'js-cookie';
import { Config } from '../../config/config';
import LZString from 'lz-string';
const { TabPane } = Tabs;

const StoreView = () => {
    const config = JSON.parse(Config);
    const apiInterface = config['api1'];
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user['userId'];
    const [title, setTitle] = useState('Stores Details');
    const dispatch = useDispatch();
    const storeDetails = useSelector(state => state?.store?.StoreDetail);
    const Stores = useSelector(state=>state?.store?.StoreDetails?.Stores)
    const isStoreView=useSelector(state => state?.store?.isStoreView);
    const lotA = useSelector(state => state.store?.LoadStore?.lotA);
    const lotB = useSelector(state => state.store?.LoadStore?.lotB)
    const loading= useSelector(state => state?.store?.loading);
    const [constructionManager, setConstructionManager] = useState('Construction Manager');
    const [storeOperationReferent, setStoreOperationReferent] = useState('Store Operations Referent');
    const [storeLeader, setStoreLeader] = useState('Store Leader');
    const [zoneOperation, setZoneOperation] = useState('Zone Operation Maintenance Coach');
    const [maintainceLeader, setMaintainceLeader] = useState('Maintenance Leader');
    const [storeImage, setStoreImage] = useState("")
    const [StoreData,setStoreData] = useState([])
    const storeId = Cookie.get('storeId');
    const [isLotA, setIsLotA] = useState(true)
    const [isLotB, setIsLotB] = useState(false)


    useEffect(() => {
        dispatch(storeViewDetails(storeId))
        let res = Stores.filter(ele=>ele.storeId == storeId);
        setStoreData(res);
    }, [])
    useEffect(() => {
        setStoreImage(`${apiInterface}/displaystoreimages?info_row_id=${storeId}&&type=1`)
    }, [isStoreView==true])
	
    const downloadFile = () => {
        // window.location.href = `${apiInterface}/maintainencefiledownload?storeid=${storeId}`
        window.location.href = `${apiInterface}/maintainencefiledownload?storeid=${storeId}&token_id=${Cookie.get('token')}`
    }
    const handleFileUpload = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setStoreImage(reader.result)
            let data = {
                fedid: userID,
                update_row_id: storeId,
                update_type: '1',
                filename: file.name,
                file: reader.result.toString().replace(/^data:(.*,)?/, '')
            }
            dispatch(doUpdateStorePic(data))
        }
        reader.onerror = error => console.log(error)
    }
    const handleLotA = () =>{
        setIsLotA(true);
        setIsLotB(false);
    }
    const handleLotB = () =>{
        setIsLotA(false);
        setIsLotB(true);
    }
    return (
        <>
            {
                loading ? <Spinner /> : <div className="wrapper">
                    <Header title={title} />
                    <Menu />
                    <div className='content-wrapper'>
                        <section className='content top-space'>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="m-panel">
                                        <div className="m-panel__body bg-dark">
                                            <div className="row">
                                                <div className="col-md-12 text-center">
                                                    <div className="c-pic">
                                                        <div className="c-pic__img">

                                                            <div className='' ><img src={storeImage} style={{maxHeight:"100%",maxWidth:'100%',borderRadius:'50%'}}/>

                                                                <label>
                                                                    <i className="fa fa-camera" aria-hidden="true"></i>
                                                                    <input type="file" id="file" style={{ display: "none" }}
                                                                        name="image" accept="image/gif,image/jpeg,image/jpg,image/png"
                                                                        data-original-title="upload photos"
                                                                        onChange={(e) => handleFileUpload(e.target.files[0])}
                                                                    />
                                                                </label>
                                                            </div>


                                                        </div>
                                                        <h5 className="c-pic__title">{storeDetails.StoreName}</h5>
                                                        <p className="c-pic__text">{storeDetails.CostCenter}</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="m-info-panel">
                                                        <div className="m-info-panel__container">
                                                            <div className="m-info-panel__item">
                                                                <h5 className="m-info-panel__title">{storeOperationReferent}</h5>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}><i className="fa fa-user"  aria-hidden="true"></i> {storeDetails.StoreOpRefName}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fa fa-phone-square" aria-hidden="true"></i>{storeDetails.StoreOpReferentNumber}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fas fa-envelope-square"></i>{storeDetails.SOREmail}</p>
                                                            </div>

                                                            <div className="m-info-panel__item">
                                                                <h5 className="m-info-panel__title">{storeLeader}</h5>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}><i className="fa fa-user" aria-hidden="true"></i> {storeDetails.StoreMgrName}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fa fa-phone-square" aria-hidden="true"></i>{storeDetails.StoreMgrNumber}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fas fa-envelope-square"></i>{storeDetails.StoreManagerEmail}</p>
                                                            </div>
                                                            <div className="m-info-panel__item">
                                                                <h5 className="m-info-panel__title">{zoneOperation}</h5>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}><i className="fa fa-user" aria-hidden="true"></i> {storeDetails.ZoneOpMCoachName}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fa fa-phone-square" aria-hidden="true"></i>{storeDetails.ZoneOpCoachNumber}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fas fa-envelope-square"></i>{storeDetails.ZOMCoachEmail}</p>
                                                            </div>
                                                            <div className="m-info-panel__item">
                                                                <h5 className="m-info-panel__title">{constructionManager}</h5>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}><i className="fa fa-user" aria-hidden="true"></i> {storeDetails.constructionMgrName}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fa fa-phone-square" aria-hidden="true"></i>{storeDetails.counsturtionMgrMobNumber}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fas fa-envelope-square"></i>{storeDetails.CMEmail}</p>
                                                            </div>

                                                            <div className="m-info-panel__item">
                                                                <h5 className="m-info-panel__title">{maintainceLeader}</h5>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}><i className="fa fa-user" aria-hidden="true"></i> {storeDetails.MaintainceLeaderName}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fa fa-phone-square" aria-hidden="true"></i>{storeDetails.MaintainceLeaderNumber}</p>
                                                                <p className="m-info-panel__text" style={{justifyContent:'left',marginLeft:49}}> <i className="fas fa-envelope-square"></i>{storeDetails.ProductLeaderEmail}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 no-pl-desktop">
                                    <div className="m-panel">
                                        <div className="m-panel__body">
                                            <button type='button' onClick={() => dispatch(StoreList(true))} className='btn muted-button -back-button-top deca-btn-orange'>Back</button>
                                            <Tabs className="m-tabs">
                                                <TabPane
                                                    tab={
                                                        <span className="inline">
                                                            <span className="box">
                                                                <i className="fa fa-globe"></i>
                                                            </span>
                                                            Property Details
                                                        </span>
                                                    }
                                                    key="2">
                                                    <div className="row no-mlr m-grid">
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Total Built-Up Area
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.TotalBuitlArea} Sqm
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Total Sale Area
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.TotalSalesArea} Sqm
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Building Type
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.BuildingType_name}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Car Parking
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.CarParking}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    No of Car Parking Lots
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.NumberOfCarParking}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    No. of two-wheeler parking lots
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.NumberOfTwoWheelerParking}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    No. of stack parking
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.NumberOfStackParking}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Playground (Concrete)
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.PlayGroundConcrete}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {storeDetails.PlayGroundConcrete == 'Yes' ? <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Playground size (In sqm)
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.PlayGroungSize}
                                                                </p>
                                                            </div>
                                                        </div> : null}
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Playground (Turf)
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.PlayGroundTurf}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {storeDetails.PlayGroundTurf == 'Yes' ? <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Playground Size (In sqm)
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.PlayGroundTurfSize}
                                                                </p>
                                                            </div>
                                                        </div> : null}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 text-right">
                                                            <div className="m-page__button top-space">
                                                                <button type="button" onClick={downloadFile} className="btn btn-secondary deca-btn-yellow" disabled ={(StoreData.length >0 && StoreData[0]?.MaintainenceChecklistOne !='' && StoreData[0]?.MaintainenceChecklistOne.includes('.'))? false:true }>Download Maintenance Split List</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPane>

                                                <TabPane
                                                    tab={
                                                        <span className="inline">
                                                            <span className="box">
                                                                <i className="fa fa-building"></i>
                                                            </span>
                                                            Asset Overview
                                                        </span>
                                                    }
                                                    key="3">
                                                    <div className="row m-grid lot_buttons">
                                                    <div className="col-md-2 no-plr-0" style={{display:'flex',justifyContent:'flex-end',border:"none"}}>
                                                            <button className = 'lot_button'type='button' onClick={handleLotA} style={{backgroundColor:isLotA ? '#3c8dbc':'#dbdbdb'}} >Lot A</button>
                                                        </div>
                                                        <div className="col-md-2 no-plr-0" style={{display:'flex',justifyContent:'flex-end',border:"none"}}>
                                                            <button className = 'lot_button' type='button' onClick={handleLotB} style={{backgroundColor:isLotB ? '#3c8dbc':'#dbdbdb'}}>Lot B</button>
                                                        </div>
                                                    </div>
                                                    {isLotA && <div className="row no-mlr m-grid">

                                                        {
                                                            lotA?.map((ele, i) => {
                                                                return (
                                                                    <div key={i} className="col-md-4 widget">
                                                                        <div className="m-widget">
                                                                            <h5 className="m-widget__title" style={{color:'black'}}>
                                                                                {ele.name}
                                                                            </h5>
                                                                            <p className="m-widget__text" style={{color:ele.available.toLowerCase()=='available'?'green':'red'}}>
                                                                                {ele.available}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>}
                                                    
                                                    {isLotB && <div className="row no-mlr m-grid">
                                                        {lotB?.map((ele, i) => {
                                                            return (
                                                                <div key={i} className="col-md-4 widget">
                                                                    <div className="m-widget">
                                                                        <h5 className="m-widget__title">
                                                                            {ele.name}
                                                                        </h5>
                                                                        <p className="m-widget__text" style={{color:ele.available.toLowerCase()=='available'?'green':'red'}}>
                                                                            {ele.available}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>}
                                                </TabPane>


                                                <TabPane
                                                    tab={
                                                        <span className="inline">
                                                            <span className="box">
                                                                <i className="fa fa-user"></i>
                                                            </span>
                                                            Landlord Details
                                                        </span>
                                                    }
                                                    key="1">
                                                    <div className="row no-mlr m-grid">
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Name
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.LandLordName}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Email
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.LandLordEmail}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Mobile Number
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.LandLordContactNumber}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Store Opening Date
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.StoreOpeningDate}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Lease period
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.LeaseStartDate}|  {storeDetails.LeaseEndDate}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Warranty / DLP end date
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.WarrantyDate}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 widget">
                                                            <div className="m-widget">
                                                                <h5 className="m-widget__title">
                                                                    Status
                                                                </h5>
                                                                <p className="m-widget__text">
                                                                    {storeDetails.Status}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPane>

                                            </Tabs>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section >
                    </div >
                    <Footer />
                </div >}
        </>
    )
}

export default StoreView;